var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content has-text-centered"},[_c('failed',{attrs:{"reason":_vm.failReason}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }